<template>
    <div style="height: 555px;">
        <div class="filter-container">
            <el-select v-model="stuListForm.courseCode" filterable placeholder="课程名称" style="width:550px;" clearable @change="loadStuList">
                <el-option v-for="item in courseInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>

            <el-button @click="exportStuList" type="primary" style="margin-left: 10px;"><i class="el-icon-download"></i>&nbsp;导出</el-button>
            <el-button @click="printStuList" type="success"><i class="el-icon-printer"></i>&nbsp;打印</el-button>
        </div>
        <el-table :data="stuListData" ref="stuList" height="500" row-key="teaCode" element-loading-text="信息加载中"
                  stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
                  style="width:100%;">
            <el-table-column label="序号" width="50" type="index" :index="indexMethod" align="center"/>
            <el-table-column label="学号" prop="stuCode" align="center"/>
            <el-table-column label="姓名" prop="stuName" align="center"/>
            <el-table-column label="性别" prop="gender" width="150px" align="center"/>
        </el-table>
    </div>
</template>

<script>
export default {
    props: ['semesterCode', 'teaCode'],
    data() {
        return {
            stuListDialogVisible: false,
            courseInfo: [],
            xnxqInfo:[],
            stuListForm: {
                semesterCode: '',
                semesterName: '',
                courseCode: '',
                courseName: '',
                id: ''
            },
            stuListData: []
        }
    },
    mounted() {
        this.stuListForm.semesterCode = this.semesterCode;
        this.stuListForm.id = this.teaCode;
        this.initCombo()
        this.loadCourse()

    },
    methods: {
        printStuList() {
            if (this.stuListForm.courseCode === '') {
                this.alertMsg('请先选择课程');
                return;
            }
            this.showLoadingMask("学生列表信息打印中，请稍候...");
            this.xnxqInfo.forEach(item => {
                if (item.comboValue === this.stuListForm.semesterCode) {
                    this.stuListForm.semesterName = item.comboName
                }
            })
            this.courseInfo.forEach(item => {
                if (item.comboValue === this.stuListForm.courseCode) {
                    this.stuListForm.courseName = item.comboName
                }
            })
            this.$api.timetableManageSkillsTraining.teaTimetable.printStuList({
                data: this.stuListForm
            }).then((res) => {
                let win = window.open(" ");
                win.document.write(res.data.data);
                win.document.close();
                win.print()
                win.close()
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        exportStuList() {
            if (this.stuListForm.courseCode === '') {
                this.alertMsg('请先选择课程');
                return;
            }
            this.showLoadingMask("学生列表信息导出中，请稍候...");
            this.xnxqInfo.forEach(item => {
                if (item.comboValue === this.stuListForm.semesterCode) {
                    this.stuListForm.semesterName = item.comboName
                }
            })
            this.courseInfo.forEach(item => {
                if (item.comboValue === this.stuListForm.courseCode) {
                    this.stuListForm.courseName = item.comboName
                }
            })
            this.$api.timetableManageSkillsTraining.teaTimetable.exportStuList({
                responseType: "blob",
                data: this.stuListForm
            }).then((res) => {
                const _this = this;
                const resultData = res.data;

                const fileReader = new FileReader();
                fileReader.onload = function () {
                    if (resultData.type == 'application/json') {
                        const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
                        showNotify('错误', jsonData.msg, 'error', 3000);
                    } else {
                        const fileName = decodeURI(res.headers['content-disposition'].split(
                            'fileName=')[1]);
                        _this.downloadFileByBlob(resultData, fileName);
                    }
                };
                fileReader.readAsText(resultData);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        loadCourse() {
            let form = {
                'id': this.teaCode,
                'semesterCode': this.semesterCode
            }
            this.$api.timetableManageSkillsTraining.teaTimetable.loadCourse({
                data: form
            }).then((res) => {
                this.courseInfo = res.data.data
            }).catch((err) => {
                console.log(err);
            });
        },
        loadStuList() {
            this.$api.timetableManageSkillsTraining.teaTimetable.loadStuList({
                data: this.stuListForm
            }).then((res) => {
                this.stuListData = res.data.data
            }).catch((err) => {
                console.log(err);
            });
        },
        indexMethod(index) {
            return index + 1;
        },
        downloadFileByBlob(data, fileName) {
            let blob = new Blob([data], {
                type: "application/ms-excel;charset=utf-8"
            });

            //浏览器兼容，Google和火狐支持a标签的download，IE不支持
            if (window.navigator && window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                let url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
            }
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        alertMsg(str) {
            this.$message({
                message: str,
                type: 'warning'
            });
        },
        initCombo() {
            this.$api.timetableManageSkillsTraining.common.semesterInfo({
				data: {
					timeType: 'endTime'
				}
			}).then((res) => {
                this.xnxqInfo = res.data.data.semesterComboData;
            }).catch((err) => {
                console.log(err);
            });
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// stuList.vue?b83a4222